import Marquee from 'react-fast-marquee';
import styles from './TextMarquee.module.css';
import { useParams } from "react-router-dom";

function TextMarquee({ firstRow, secondRow }) {

    const { lang } = useParams();

    return (

        <div className={`${styles.textMarquee} ${lang === "ko" && styles.lang_ko}`}>
            <Marquee loop={0} direction="left">
                <span>
                    <h2>{firstRow}</h2>
                </span>
                <span>
                    <h2>{firstRow}</h2>
                </span>
                <span>
                    <h2>{firstRow}</h2>
                </span>

            </Marquee>
            <Marquee loop={0} direction="right">
                <span>
                    <h2>{secondRow}</h2>
                </span>
                <span>
                    <h2>{secondRow}</h2>
                </span>
                <span>
                    <h2>{secondRow}</h2>
                </span>
            </Marquee>
        </div>
    )
}

export default TextMarquee;
